import { PatientDetailsValidationSchema } from '../../RequestForm/PatientDetails/PatientDetailsValidationSchema';
import { INVALID_EMAIL } from '../../../utilities/Validation/ValidationMessages';

export const SetupMyInformationValidationSchema = {
	preferredEmail: {
		...PatientDetailsValidationSchema.patientEmail,
		required: INVALID_EMAIL
	}
};
